export const notificationMessages = [
    {
        id: "featureDisabled",
        type: "error",
        message: "This feature is disabled",
        linkText: "Hopefully it will be working soon",
    },


    // Chems Notifications
    {
        id: "chemDelete",
        type: "success",
        message: "Product Successfully Deleted",
    },
    {
        id: "chemDeleteError",
        type: "error",
        message: "Product Failed to Delete",
    },
    {
        id: "chemUpdated",
        type: "update",
        message: "Product Updated Successfully",
    },
    {
        id: "chemUpdatedError",
        type: "error",
        message: "Product Failed to Update",
    },
    {
        id: "chemAdded",
        type: "success",
        message: "Product Added to your Inventory Successfully",
    },
    {
        id: "chemAddedError",
        type: "error",
        message: "Product Failed to be Added to your Inventory",
    },
    {
        id: "chemDup",
        type: "success",
        message: "Product Successfully Duplicated",
    },
    {
        id: "chemDupError",
        type: "error",
        message: "Product Failed to be Duplicated",
    },
    {
        id: "inventoryUpdate",
        type: "update",
        message: "Inventory Successfully Updated",
    },
    {
        id: "inventoryUpdateError",
        type: "error",
        message: "Inventory Failed to Update",
    },
    {
        id: "stock",
        type: "update",
        message: "Stock Updated Successfully",
    },
    {
        id: "stockError",
        type: "error",
        message: "Stock Failed to Update",
    },



    {
        id: "formError",
        type: "error",
        message: "There was an error submitting the form.",
        linkText: "Try again.",
    },
    // Add more as needed...
];
